import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGlobalsService } from '../services/app-globals.service';
import { BookManagementComponent } from './book-management-shell/book-management.component';
import { CarrierPortalComponent } from '../carrier-portal/carrier-portal.component';
import { AuthService } from '../services/auth-service.service';

const routes: Routes = [
  {
    path: 'carrier-portal',
    pathMatch: 'full',
    component: CarrierPortalComponent,
    canActivate: [AuthService],
    data: {
      rightNeeded: {
        rights: ['CarrierPortal', 'HomeOfficeCarrierPortal'],
        operation: 'or',
      },
    },
  },
  {
    path: 'carrier-policy-details',
    pathMatch: 'full',
    component: CarrierPortalComponent,
    canActivate: [AuthService],
    data: {
      rightNeeded: 'CarrierPortalPolicyDetails',
    },
  },
  {
    path: 'book-management',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: 'home-office',
        pathMatch: 'full',
        component: BookManagementComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'BookManagement',
          breadcrumb: 'Book Management',
        },
      },
      {
        path: 'rep-reports',
        pathMatch: 'full',
        component: BookManagementComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'BookManagement',
          breadcrumb: 'Book Management',
        },
      },
      {
        path: '',
        component: BookManagementComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'BookManagement',
          breadcrumb: 'Book Management',
        },
      },
      {
        path: ':id',
        component: BookManagementComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'BookManagement',
          breadcrumb: 'Book Management',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookManagementRouting {}
